import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'tech-talk',
});

export const editTechTalkRouteRef = createRouteRef({
  id: 'tech-talk:edit',
  params: ['name'],
});
